<template>
  <div :id="idattr" class="loadingbox" :style="styleObj">
  </div>
</template>

<script>

import lottie from 'lottie-web'
export default {
  name:'LottieLoading',
  props: {
    styleObj: {
      type: String
    },
    path:{
      type:String
    },
    idattr:{
      type:String,
      default:'loadingbox'
    }
  },

  mounted() {
    this.intLottie()
  },
  methods: {
    // lottie动画渲染
    intLottie() {
      // 渲染主图按钮动画
      let lottieBox = lottie.loadAnimation({
        container: document.getElementById(this.idattr), // 包含动画的dom元素
        renderer: 'svg', // 渲染出来的是什么格式
        loop: true, // 循环播放
        autoplay: true, // 自动播放
        path: this.path
      });
      lottieBox['addEventListener']('complete', () => {
        console.log('完成')
      });
    },
  }
}
</script>
